module.exports = __webpack_public_path__ + "static/media/3dim-tr_s-w2S.a53640a4.png";